module.exports = __webpack_public_path__ + "static/media/selectedplan.9fb70a2e.PNG";